// extracted by mini-css-extract-plugin
export default {"tenant":"styles_tenant__abTFN","tenantInfo":"styles_tenantInfo__w4aEG"};